import _get from 'lodash/get';
import { ColorEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/documentCategoryFieldNames';

export default function getPreparedDataFromValues(values: Values) {
  return {
    name: _get(values, FieldNames.Name, '') as string,
    // The color option value is the backend `ColorEnum` (e.g. `BLUE`).
    color: _get(values, `${FieldNames.Color}.value`, '') as ColorEnum,
    description: _get(values, FieldNames.Description, '') as string,
    allowDownload: _get(values, FieldNames.AllowDownload, false) as boolean,
    allowPrint: _get(values, FieldNames.AllowPrint, false) as boolean,
  };
}
